export default {
  'download_format_modal_title': 'Download Settings',
  'download_format_modal_Metrics': 'Metrics',
  'download_format_modal_Data': 'Data Change',
  'download_format_modal_Data_Statistics': 'Data Statistics',
  'download_format_modal_File_Format': 'File Format',
  'download_format_modal_Excel': 'Excel',
  'download_format_modal_CSV': 'CSV',
  'download_format_modal_Value_Only': 'Value Only',
  'download_format_modal_Value_and_DoD_Day': 'Value and DoD',
  'download_format_modal_Value_and_DoD_Week': 'Value and WoW',
  'download_format_modal_Value_and_DoD_Month': 'Value and MoM',
  'download_format_modal_Value_and_SDLW_Day': 'Value and SDLW',
  'download_format_modal_Value_and_SDLW_Week': 'Value and SWLM',
  'download_format_modal_Value_and_SDLW_Month': 'Value and SMLY',
  'download_format_modal_Confirm': 'Confirm',
  'download_format_modal_Cancel': 'Cancel',
  'download_format_modal_All': 'All',
  'download_format_modal_data_only': 'Data Only',
  'download_format_modal_more_statistics': 'Data and More Statistics(Sum&Average)',
}
